import { memo, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { ReactComponent as SettingsIcon } from '../../../../assets/icons/main/settings-icon.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/main/close-icon.svg';
import { ReactComponent as ScanIcon } from '../../../../assets/icons/main/scan-icon.svg';
import { ReactComponent as AlertIcon } from '../../../../assets/icons/main/alertIcon.svg';
import { ReactComponent as ResizeIcon } from '../../../../assets/icons/resize-icon.svg';
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Drawer,
  FormControlLabel,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  darken,
  lighten,
  useTheme,
} from '@mui/material';
import { IconButton } from '@mui/material';
import DataTable from '../../../../components/DataTable';
import Checkbox from '@mui/material/Checkbox';
import AccordionComponent from './AccordionComponent';
import { JsonForms } from '@jsonforms/react';
import { materialCells, materialRenderers } from '@jsonforms/material-renderers';
import './styles.scss';
import { EditorContext, TelemetryContext } from '../context';
import { Edge, getConnectedEdges, getIncomers, getOutgoers, Node, useEdges, useNodes } from 'reactflow';
import { AssetSchema, AssetUISchema } from '../panel-schemas';
import { ListAltRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import Modal from '../../../Modal';
import { createAjv, toDataPathSegments } from '@jsonforms/core';
import keywords from 'ajv-keywords';
import Switch from '@mui/material/Switch';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NodeItem } from '../index';
import { uniqBy, cloneDeep, get, isEmpty, uniq, set, isEqual } from 'lodash';
import { useSnackbar } from 'notistack';
import { v4 } from 'uuid';
import { connect } from 'react-redux';
import JsonFormsWrapper from './JsonFormsWrapper';
import PopUp from '../../../../components/Popup';
import { ReactComponent as AddCircleIcon } from '../../../../assets/icons/main/plus-circle-icon.svg';
import { ReactComponent as ExcelIcon } from '../../../../assets/icons/main/microsoft-excel-icon.svg';
import { ReactComponent as ExpandMoreIcon } from '../../../../assets/icons/main/chevron-down-icon.svg';
import { ReactComponent as CloseCircleIcon } from '../../../../assets/icons/main/close-circle-icon.svg';
import { palette } from '../../../../theme/palette';
import { useOutletContext } from 'react-router-dom';
import lightOrdarkColor from '@check-light-or-dark/color';
import CommonStyles from '../../../../theme/commonCss/Styles';
import { useDispatch } from 'react-redux';
import { secretManagerActions } from '../../../../store/reducers/secret-manager';
import { factoryManagementActions } from '../../../../store/reducers/factory-management';
import ScanResults from './ScanResults';

const ajv = createAjv({
  allErrors: true,
  verbose: false,
  strict: false,
  inlineRefs: false,
});

keywords(ajv, 'uniqueItemProperties');
//check 64 - 71 that we can add custom msgs in doc.

interface SidebarProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<any>>;
  nodes: any;
  setNodes: React.Dispatch<React.SetStateAction<any>>;
  activeNode: any;
  nodeElement: any;
  readonly: boolean;
  components: any[];
  assetCompsData: any;
  setAssetCompsData: any;
  setJsonFormError: any;
  jsonFormError: any;
  updateNodeData: any;
  secretsList: any;
  hasAccessTo: any;
  assetComponentsLoading: boolean;
  assetComponents: any;
  componentsLoading: boolean;
  secretError: any;
  setSecretError: any;
  myUniqueId: string;
  setRemovedComponents: React.Dispatch<React.SetStateAction<any[]>>;
  factoryId?: string;
  setActiveComponentId: React.Dispatch<React.SetStateAction<number | null>>;
  loadingCopyConfigurationFromComponent: boolean;
}

const checkForAction = (scanProp: any, data: any) => {
  if (isEmpty(scanProp)) return false;
  if (!scanProp.rule || !scanProp.rule.condition) return true;

  const scanRuleScope = get(scanProp, 'rule.condition.scope', '');
  const scanRuleConst = get(scanProp, 'rule.condition.schema.const');
  const scanDataPathSegments = toDataPathSegments(scanRuleScope);
  const scanRuleValue = get(data, scanDataPathSegments);

  return scanRuleValue === scanRuleConst;
}

function findObjectsWithKey(obj: any, key: any, path: any = []) {
  let results: any = [];
  if (typeof obj === 'object' && obj !== null) {
    if (obj.hasOwnProperty(key)) {
      results.push({ path: [...path], object: obj });
    }
    for (const k in obj) {
      results = results.concat(findObjectsWithKey(obj[k], key, [...path, k]));
    }
  }
  return results;
}

const Styles = {
  scanText: { fontSize: '1rem', fontWeight: 400 },
  scanWrapper: { display: 'flex', justifyContent: 'space-between', width: '100%' },
  scanField: {
    flexGrow: 1,
    height: '42px',
    backgroundColor: palette.primary.contrastText,
    borderRadius: '8px',

    // '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    //   backgroundColor: '#edf1f6',
    //   borderColor: '#c5cad7',
    // },
  },
  scanBtn: {
    width: '109px',
    height: '42px',
    fontSize: 16,
    backgroundColor: '#68CB00',

    '&:disabled': {
      '& .MuiCircularProgress-svg': {
        color: '#fff',
      },
      '& svg': {
        filter:
          'brightness(0) saturate(100%) invert(77%) sepia(1%) saturate(1512%) hue-rotate(181deg) brightness(99%) contrast(97%)',
      },
    },
  },
  btn: { width: 'auto', flexGrow: 1, height: '42px' },
  Sidebar: {
    // width: '780px',
    height: '100vh',
    padding: '24px 32px',
    boxSizing: 'border-box',
    boxShadow: '-4px 0px 14px 0px rgba(0, 0, 0, 0.15)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '24px',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontWeight: 600,
    marginLeft: '12px',
    textTransform: 'uppercase',
  },
  body: {
    height: 'calc(100vh - 218px)',
    paddingBlock: '24px',
    overflow: 'auto',
  },
  tableWrapper: {
    // overflow: 'auto',
    position: 'relative',
  },
  card: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    borderRadius: '8px',
    boxShadow: 'none',
    boxSizing: 'border-box',
    height: 'auto',
    marginBottom: '24px',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
  },
  listHeading: {
    // color: '#64759F',
    fontSize: '1rem',
    marginRight: '12px',
    lineHeight: '22px',
    width: '74px',
    textAlign: 'right',
    letterSpacing: '1px',
  },
  listText: {
    fontSize: '1rem',
    lineHeight: '22px',
    letterSpacing: '1px',
  },
  footer: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'center',
    gap: '24px',
  },
  checkBox: {
    '& .MuiSvgIcon-root': { fontSize: '1.5rem !important' },
    '&:not(.Mui-disabled) .MuiSvgIcon-root': { color: '#5C85FF !important' },
    '&.Mui-disabled .MuiSvgIcon-root': { color: 'lightgrey !important' },
  },
  deleteIcon: {
    fontSize: '1.5rem !important',
    cursor: 'pointer',
  },
  inputField: {
    '& .MuiInputBase-input': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  accordionHeader: {
    padding: '0px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    boxSizing: 'border-box',
  },
  closeIcon: {
    cursor: 'pointer',
  },
  loaderWrapper: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 2,
    bgcolor: 'rgba(255, 255, 255, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const schemas: any = {
  assetNode: {
    schema: AssetSchema,
    uiSchema: AssetUISchema,
  },
};

const Sidebar = ({
  isDrawerOpen,
  setIsDrawerOpen,
  setNodes,
  activeNode,
  nodeElement,
  readonly,
  components,
  assetCompsData,
  setAssetCompsData,
  updateNodeData,
  setJsonFormError,
  jsonFormError,
  secretsList,
  hasAccessTo,
  assetComponentsLoading,
  assetComponents,
  componentsLoading,
  secretError,
  setSecretError,
  myUniqueId,
  setRemovedComponents,
  setActiveComponentId,
  loadingCopyConfigurationFromComponent,
}: SidebarProps) => {
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  const nodes: Node[] = useNodes();
  const edges: Edge[] = useEdges();
  const {
    updateData,
    scanAssets,
    scanTags,
    scanning,
    scanningTags,
    editable,
    useCase,
    onBtnClick,
    setScanningTags,
    stopScan,
    disableScanStop,
    scanningGateways,
    onGatewayImportClick,
  } = useContext(EditorContext);
  const { telemetry } = useContext(TelemetryContext);

  const [tagsView, setTagsView] = useState(false);
  const [activeComponent, setActiveComponent] = useState<any | null>(null);
  const [deleteComponentConfirmation, setDeleteComponentConfirmation] = useState({ open: false, compId: '' });
  const [jsonFormAlertPopup, setJsonFormAlertPopup] = useState<any>({ open: false, msg: '' });
  const [jsonFormErrorPopup, setJsonFormErrorPopup] = useState<any>({ open: false, msg: '' });
  const dispatch = useDispatch();

 useEffect(() => {
    dispatch(secretManagerActions.getSecretsRequest({}));
    dispatch(
      factoryManagementActions.getFactoriesList({
        page: 1,
        limit: 1000,
        pageName: 'Factory',
      })
    );
  }, []);

  const noAccessToEdit = !(hasAccessTo.create && hasAccessTo.update);

  const toggleDrawer = () => {
    const errorMsgs: any = [];
    const warningMsgs: any = [];
    const whitespaceErrorPatterns = [
      'message name must not start or end with whitespace.',
      'key must not contain whitespace.'
    ];  

    Object.keys(jsonFormError).forEach((err) => {
      const secretsErrors = jsonFormError[err].secretErrors?.secret_message || [];
      const errors = jsonFormError[err].errors || [];
      
      if (errors.length || secretsErrors.length > 0) {
        const wsErrors = errors.filter(({ message }: { message: string }) => 
          whitespaceErrorPatterns.some(pattern => message.toLowerCase() === pattern.toLowerCase())
        );
        const otherErrors = errors.filter(({ message }: { message: string }) => 
          !whitespaceErrorPatterns.some(pattern => message.toLowerCase() === pattern.toLowerCase())
        );

        // Add whitespace errors to error modal
        if (wsErrors.length > 0) {
          errorMsgs.push(
            <Box key={`error-${err}`} sx={{ mt: errorMsgs.length === 0 ? 0 : 2, p: 2, bgcolor: '#ffe6e6', borderLeft: '4px solid #FF0000' }}>
              <Typography color='#FF0000' fontSize={18} fontWeight={600} textAlign='left'>
                {jsonFormError[err].componentName}
              </Typography>
              <ul style={{ textAlign: 'left', marginLeft: 8, listStylePosition: 'inside' }}>
                {wsErrors.map(({ message }: { message: string }, idx: number) => (
                  <li key={idx}>{message}</li>
                ))}
              </ul>
            </Box>
          );
        }

        // Add other errors and secrets warnings to warning modal
        if (otherErrors.length > 0 || secretsErrors.length > 0) {
          warningMsgs.push(
            <Box key={`warning-${err}`} sx={{ mt: warningMsgs.length === 0 ? 0 : 2, p: 2, bgcolor: '#fff4e6', borderLeft: '4px solid #FF8800' }}>
              <Typography color='#FF8800' fontSize={18} fontWeight={600} textAlign='left'>
                {jsonFormError[err].componentName}
              </Typography>
              {otherErrors.length > 0 && (
                <ul style={{ textAlign: 'left', marginLeft: 8, listStylePosition: 'inside' }}>
                  {otherErrors.map(({ message }: { message: string }, idx: number) => (
                    <li key={idx}>{message}</li>
                  ))}
                </ul>
              )}
              {secretsErrors.length > 0 && (
                <Box sx={{ mt: otherErrors.length > 0 ? 2 : 0 }}>
                  <Typography color='#FF8800' fontSize={14} fontWeight={600} textAlign='left'>
                    Secrets Warnings
                  </Typography>
                  <ul style={{ textAlign: 'left', marginLeft: 8, listStylePosition: 'inside' }}>
                    {secretsErrors.map((msg: any, idx: number) => (
                      <li key={idx}>{msg}</li>
                    ))}
                  </ul>
                </Box>
              )}
            </Box>
          );
        }
      }
    });

    if (activeNode?.type === 'assetNode') {
      if (errorMsgs.length) {
        setJsonFormErrorPopup({ open: true, msg: <>{errorMsgs}</> });
      } else if (warningMsgs.length) {
        setJsonFormAlertPopup({ open: true, msg: <>{warningMsgs}</> });
      } else {
        setIsDrawerOpen(false);
      }
    } else {
      setIsDrawerOpen(false);
    }
  };

  const renderCardData = (server: {
    label: string | undefined;
    name: string | undefined;
    address: string | undefined;
    services: {
      port: string;
    };
  }) => (
    <>
      <Box sx={Styles.listItem}>
        <Typography sx={Styles.listHeading}>Type:</Typography>
        <Typography sx={Styles.listText}>{server.label}</Typography>
      </Box>
      <Box sx={Styles.listItem}>
        <Typography sx={Styles.listHeading}>Name:</Typography>
        <Typography sx={Styles.listText}>{server.name ?? 'No hostname setup'}</Typography>
      </Box>
      <Box sx={Styles.listItem}>
        <Typography sx={Styles.listHeading}>Address:</Typography>
        <Typography sx={Styles.listText}>{activeNode?.data?.ip ?? server.address}</Typography>
      </Box>
    </>
  );

  const gateway: Node<any> | null = useMemo(
    () => (activeNode ? nodes.find((node: Node) => node.id === activeNode?.connectedTo) ?? null : null),
    [nodes, activeNode]
  );

  const compSchemas = useMemo(() => {
    const sch: Record<number, any> = {};
    activeNode?.data?.options?.forEach((component: any) => {
      const comp = components.find((comp: any) => String(comp.component_id) === String(component.component_id));
      const schema = {
        schema: cloneDeep(comp?.backend_schema ?? schemas[activeNode?.type]?.backend_schema),
        uiSchema: cloneDeep(comp?.ui_schema ?? schemas[activeNode?.type]?.uiSchema),
      };
      sch[comp?.component_id ?? 'blah'] = schema;
    });
    return sch;
  }, [components, activeNode]);

  const renderJsonDataTable = (data: any) => {
    // data?.options?.map((component: any) => {
    return data?.options?.map((component: any) => {
      const schema = compSchemas[component.component_id];
      if (component?.data?.scan_result?.length > 0) {
        if (get(schema, 'schema.scanResult.scope')){
          const dotPath = get(schema, 'schema.scanResult.scope').replace(/^#\//, '').replace(/\//g, '.');
          const scanResult = get(component, 'data.scan_result', []);
          const isOneOf = get(schema, 'schema.scanResult.oneOf');
          if (isOneOf) {
            const titleKey = get(schema, 'schema.scanResult.columns[0].value', 'id');
            const constKey = get(schema, 'schema.scanResult.columns[1].value', 'id');
            set(schema.schema, `${dotPath}.oneOf`, uniqBy(scanResult, constKey).map((tag: any) => ({
              title: tag[titleKey],
              const: tag[constKey],
            })));
          } else {
            const key = get(schema, 'schema.scanResult.columns[0].value', 'id');
            set(schema.schema, `${dotPath}.enum`, uniq(scanResult.map((tag: any) => tag[key])));
          }
        } else {
          const results = findObjectsWithKey(schema, 'scanResults');
          if (results && results.length > 0) {
            results.forEach((result: any) => {
              const enumData = uniq(
                component.data.scan_result.map((tag: any) =>
                  result.object.scanResultsKey ? tag[result.object.scanResultsKey] : tag.id,
                ),
              );
              set(schema, [...result.path, 'enum'], enumData);
            });
          } else {
            const uniqueTagIds = uniq(component.data.scan_result.map((tag: any) => tag.id));
            const messagesProps = schema?.schema?.properties?.messages?.items?.properties;

            if (messagesProps?.trigger) {
              messagesProps.trigger.enum = uniqueTagIds;
            }
            if (messagesProps?.props?.items?.properties?.id) {
              messagesProps.props.items.properties.id.enum = uniqueTagIds;
            }
          }
        }
      }

      const jsonSchema = schema?.schema ?? component?.panel?.schema ?? activeNode?.panel?.schema;
      const jsonUISchema = schema?.uiSchema ?? component?.panel?.uiSchema ?? activeNode?.panel?.uiSchema;

      const secretFieldKeys = jsonSchema?.properties
        ? Object.keys(jsonSchema.properties).filter(key =>
            jsonSchema.properties[key]?.secret === true
          )
        : [];

      // if (assetComponentsLoading || componentsLoading) return null;
      if (jsonSchema?.properties?.secret?.oneOf && secretsList.length) {
        jsonSchema.properties.secret.oneOf = secretsList.map(({ label, value }: { label: string; value: string }) => ({
          title: label,
          const: value,
        }));
      }

      const scanProp = get(jsonUISchema, 'actions', []).find((action: any) => action.action === 'scan') || {};
      const viewProp = get(jsonUISchema, 'actions', []).find((action: any) => action.action === 'view') || {};

      const showScan = jsonUISchema?.action === 'scan' || checkForAction(scanProp, component.data);
      const showView = jsonUISchema?.action === 'scan' || checkForAction(viewProp, component.data);

      return (
        <AccordionComponent
          key={component.id}
          title={component.component_name ?? ''}
          checked={data?.enabled ? component.enabled : false}
          onCheck={() => {
            updateData({
              options: [
                ...data.options.map((op: any) => {
                  if (op.id === component.id) {
                    op.enabled = !component.enabled;
                    op.operation = get(component, 'operation', 'edited');
                  }
                  return op;
                }),
              ],
            });
          }}
          onChange={(isExpanded: Boolean) => {
            if (component.id !== assetCompsData?.component?.id) {
              setAssetCompsData({
                component,
                activeNode,
                // isEnabled: !data.enabled || !component.enabled,
                gatewayId: gateway?.data?.gateway_id ?? '',
              });
              setActiveComponentId(component.component_id);
            } else {
              setAssetCompsData({});
            }
          }}
          onDelete={() => {
            setDeleteComponentConfirmation({ open: true, compId: component.id });
          }}
          expanded={component.id === assetCompsData?.component?.id}          
          disabled={data?.enabled === false || noAccessToEdit}
          hasErrors={
            get(jsonFormError, `component-${component.id}.errors.length`) ||
            get(jsonFormError, `component-${component.id}.secretErrors.secret_message.length`)
          }
        >
          <Box sx={Styles.tableWrapper}>
            {loadingCopyConfigurationFromComponent && (
              <Box sx={Styles.loaderWrapper}>
                <CircularProgress size={24} sx={{ color: themeData.palette.primary.main, mr: 1 }} />
              </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 1 }}>
              {showScan && (
                <>
                  {scanningTags.includes(component.uuid) ? (
                    <Button
                      variant='contained'
                      onClick={() => {
                        stopScan(gateway?.data?.gateway_id ?? '', component.uuid);
                      }}
                      startIcon={<CircularProgress size={16} sx={{ color: '#fff' }} />}
                      disabled={disableScanStop[component.uuid] || noAccessToEdit}
                    >
                      STOP
                    </Button>
                  ) : (
                    <Button
                      variant='contained'
                      onClick={() => scanTags(gateway?.data?.gateway_id ?? '', component)}
                      disabled={
                        !data.enabled || !component.enabled || disableScanStop[activeNode?.id] || noAccessToEdit
                      }
                      startIcon={<ScanIcon />}
                    >
                      SCAN
                    </Button>
                  )}
                </>
              )}
              {showView && (
                <Button
                  onClick={() => {
                    setTagsView(true);
                    setActiveComponent(component);
                  }}
                  variant='outlined'
                  disabled={!data.enabled || !component.enabled}
                >
                  View
                </Button>
              )}
            </Box>
            <Box className='jsonFormsWrapper'>
              <JsonFormsWrapper
                schema={jsonSchema}
                uiSchema={jsonUISchema}
                data={component.data}
                readOnly={!data.enabled || !component.enabled || noAccessToEdit}
                onChange={({ data: formData, errors }: any) => {
                  setJsonFormError((errs: any) => ({
                    ...errs,
                    ['component-' + component.id]: {
                      componentName: component.component_name,
                      errors: component.enabled
                        ? errors.filter((error: any) => {
                            const isSecretFieldError = secretFieldKeys.some(
                              (secretKey) =>
                                error.instancePath.includes(`/${secretKey}`) || error.instancePath.includes(secretKey)
                            );
                            return !(isSecretFieldError || error.instancePath.includes('copy_configuration_from'));
                          })
                        : [],
                      secretErrors: component.enabled
                        ? validateConfig(formData, secretsList, jsonSchema?.required_secrets)
                        : { secret_message: [] },
                    },
                  }));
                  const nextOptions = (data?.options ?? activeNode?.data?.options ?? []).map((option: any) => {
                    const copiedOption = { ...option };
                    if (copiedOption.id === component.id) {
                      const hasDataChanged = !isEqual(copiedOption.data ?? {}, formData ?? {});
                      copiedOption.data = formData;
                      if (hasDataChanged) {
                        copiedOption.operation = get(copiedOption, 'operation', 'edited');
                      }
                    }
                    return copiedOption;
                  });
                  updateData({ options: nextOptions }, true);

                  setAssetCompsData((prev: any) => ({
                    ...prev,
                    component: {
                      ...prev.component,
                      data: { ...(formData || {}) },
                    },
                  }));
                }}
                hasErrors={
                  get(jsonFormError, `component-${component.id}.errors.length`) ||
                  get(jsonFormError, `component-${component.id}.secretErrors.secret_message.length`)
                }
              />
            </Box>
          </Box>
        </AccordionComponent>
      );
    });
  };

  const renderDataTable = (edgeId: string, serverId: string, rows: any[]) => {
    const otherAssets = (nodes as unknown[] as NodeItem[]).filter(
      (node: NodeItem) => node.connectedTo === activeNode?.connectedTo && node.id !== activeNode?.id
    ) as unknown[] as Node[];
    const usedParams =
      otherAssets.flatMap(
        (node: Node) =>
          node.data?.props?.map((prop: any) => ({ ...prop, nodeId: node.id, usedBy: node.data?.machine_name })) ?? []
      ) ?? [];
    const columns = [
      {
        field: 'dashboard',
        headerName: 'select',
        width: 100,
        sortable: false,
        renderCell: (params: any) => {
          return (
            <Checkbox
              disabled={usedParams?.find((param: any) => param.id === params.row.id)}
              sx={Styles.checkBox}
              checked={activeNode?.data?.props?.find((prop: any) => prop.id === params.row.id)}
              onChange={(e, v) => {
                if (v) {
                  updateData({
                    props: [...(activeNode?.data?.props ?? []), params.row],
                  });
                } else {
                  updateData({
                    props: [...(activeNode?.data?.props ?? [])?.filter((prop: any) => prop.id !== params.row.id)],
                  });
                }
              }}
            />
          );
        },
      },
      {
        field: 'key',
        headerName: 'Display Name',
        flex: 1,
      },
      {
        field: 'usedBy',
        headerName: 'Used By',
        renderCell: (params: any) => {
          return (
            (activeNode?.data?.props?.find((prop: any) => prop.id === params.row.id)
              ? 'This'
              : usedParams?.find((prop: any) => prop.id === params.row.id)?.usedBy) ?? 'Not Used'
          );
        },
        flex: 1,
      },
    ];

    return (
      <Box className={'params-table'}>
        <Typography sx={{ fontWeight: 400, textAlign: 'center', height: '51px', marginTop: '24px' }}>
          Parameters Available
        </Typography>
        <DataTable
          rows={rows}
          columns={columns}
          autoHeight
          tableHeight={`${rows.length * 52 + 10}px`}
          hideFooter
          hideBorders
        />
      </Box>
    );
  };

  const renderParamsTable = (rows: any[]) => {
    const columns = [
      {
        field: 'key',
        headerName: 'Display Name',
        flex: 1,
      },
      {
        field: 'value',
        headerName: 'Value',
        flex: 1,
      },
      {
        field: 'uom',
        headerName: 'UOM',
        flex: 1,
      },
    ];

    return (
      <Box className={'params-table'}>
        <Typography sx={{ fontWeight: 400, textAlign: 'center', height: '51px', marginTop: '24px' }}>
          Parameters
        </Typography>
        <DataTable
          rows={rows}
          columns={columns}
          // autoHeight
          tableHeight={`${rows.length * 67 + 10}px`}
          hideFooter
          hideBorders
        />
      </Box>
    );
  };

  const renderBody = (nodeType: string, data: any) => {
    const item = nodeElement.data;
    switch (nodeType) {
      case 'machineNode':
        const incomers = nodes.filter((node: Node) => node.id === activeNode?.connectedTo) as unknown[] as (Node &
          NodeItem)[];
        const servers: any[] = [];
        for (let incomer of incomers) {
          servers.push(
            ...(incomer.data?.options ?? [])?.map((server: any) => ({
              ...server,
              name: incomer.data?.name,
              edge: incomer.id,
              address: incomer.data.ip,
              props: uniqBy(server.data?.messages?.flatMap((message: any) => message.props) ?? [], 'id'),
            }))
          );
        }
        return (
          <Box>
            {servers.map((item) => (
              <AccordionComponent
                key={item.id}
                title={item.component_name}
                // header={<Box sx={Styles.accordionHeader}>{renderCardData(item)}</Box>}
                disabled={noAccessToEdit}
                hideDelete
              >
                {readonly
                  ? renderParamsTable(
                    item.props
                      ?.filter((prop: any) => prop.usedBy === nodeElement.part_id)
                      ?.map((prop: any) => {
                        const machines = getIncomers(activeNode, nodes, edges);
                        let value = 'NOT_FOUND';
                        for (let machine of machines) {
                          const gateways = getIncomers(machine, nodes, edges);
                          const gateway = gateways?.[0] ?? [];
                          value =
                            telemetry[item.edge]?.properties?.find((p: any) => p.name === prop.key)?.value ?? value;
                        }
                        return { ...prop, value };
                      }) ?? []
                  )
                  : renderDataTable(
                    incomers[0]?.connectedTo ?? '',
                    item?.id,
                    item?.props?.filter((prop: any) => !!prop?.id) || []
                  )}
              </AccordionComponent>
            ))}
          </Box>
        );
      case 'controllerNode':
      case 'assetNode':
        const liveNodeData = activeNode?.data ?? data;
        const scanFieldStyles = {
          ...Styles.scanField,
          '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor:
              lightOrdarkColor(themeData.palette.background.default) === 'dark'
                ? lighten(themeData.palette.background.default, 0.6)
                : darken(themeData.palette.background.default, 0.2),
          },
        };
        return (
          <>
            <Card
              sx={{
                ...Styles.card,
                backgroundColor: themeMode.isLightBG
                  ? lighten(themeData.palette.background.default, 0.2)
                  : lighten(themeData.palette.background.default, 0.08),
              }}
            >
              <Stack direction={'column'} spacing={2} sx={Styles.scanWrapper}>
                {editable && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={liveNodeData.enabled}
                        onChange={(_event, checked) => {
                          updateData({
                            force_update_id: activeNode?.id,
                            enabled: checked,
                          });
                        }}
                      />
                    }
                    label={<Typography style={{ color: themeData.palette.text.primary }}>Enable Asset</Typography>}
                    labelPlacement='start'
                    sx={{ justifyContent: 'flex-end', gap: 1 }}
                    disabled={noAccessToEdit}
                  />
                )}
                <TextField
                  placeholder='Asset name'
                  disabled={!editable || !liveNodeData.enabled || noAccessToEdit}
                  value={liveNodeData.name}
                  onChange={(e) => updateData({ name: e.target.value })}
                  sx={scanFieldStyles}
                />
                <TextField
                  placeholder='Asset IP Address'
                  disabled={!editable || !liveNodeData.enabled || noAccessToEdit}
                  value={liveNodeData.ip}
                  onChange={(e) => updateData({ ip: e.target.value })}
                  sx={scanFieldStyles}
                />
              </Stack>
            </Card>
            {readonly
              ? liveNodeData?.options?.map((component: any) => {
                const props = uniqBy(component.data?.messages?.flatMap((message: any) => message.props) ?? [], 'id');
                return (
                  <AccordionComponent title={component.component_name ?? ''} key={component.id} hideToggle hideDelete>
                    <Box sx={Styles.tableWrapper}>
                      <Stack direction={'row'} justifyContent={'space-between'}>
                        <Typography sx={{ fontWeight: 400, textAlign: 'center', height: '51px', marginTop: '24px' }}>
                          Parameter values
                        </Typography>
                      </Stack>
                      <Box className='jsonFormsWrapper'>
                        {renderParamsTable(
                          props?.map((prop: any) => {
                            const value =
                              telemetry[data.id]?.properties?.find((p: any) => p.name === prop.key)?.value ??
                              'NOT_FOUND';
                            return { ...prop, value };
                          }) ?? []
                        )}
                      </Box>
                    </Box>
                  </AccordionComponent>
                );
              })
              : renderJsonDataTable(liveNodeData)}
            {editable && (
              <Stack sx={{ mt: 2 }}>
                <Button
                  disabled={!liveNodeData.enabled || noAccessToEdit || assetComponentsLoading}
                  variant='outlined'
                  sx={Styles.btn}
                  startIcon={<AddCircleIcon />}
                  onClick={() => {
                    onBtnClick('assetNode', { label: 'Add component', type: 'add_service' });
                  }}
                >
                  Add component
                </Button>
              </Stack>
            )}
          </>
        );
      case 'edgeNode':
        const liveGatewayData = activeNode?.data ?? data;
        const gatewayCommandId = `gateway:${myUniqueId}:${liveGatewayData.gateway_id}`;
        return (
          <>
            <Card
              sx={{
                ...Styles.card,
                backgroundColor: themeMode.isLightBG
                  ? lighten(themeData.palette.background.default, 0.2)
                  : lighten(themeData.palette.background.default, 0.08),
              }}
            >
              <Box sx={Styles.listItem}>
                <Typography sx={Styles.listHeading}>Name :</Typography>
                <Typography sx={Styles.listText}>{liveGatewayData.name ?? ''}</Typography>
              </Box>
              <Stack direction={'row'} spacing={2} sx={Styles.scanWrapper}>
                <TextField
                  variant='outlined'
                  disabled={!editable || noAccessToEdit}
                  value={liveGatewayData.cidr_to_scan ?? ''}
                  onChange={(e) => updateData({ cidr_to_scan: e.target.value })}
                  sx={{
                    ...Styles.scanField,
                  }}
                />
                {scanningGateways.includes(gatewayCommandId) ? (
                  <Button
                    variant='contained'
                    onClick={() => {
                      stopScan(liveGatewayData?.gateway_id ?? '', gatewayCommandId);
                    }}
                    startIcon={<CircularProgress size={16} sx={{ color: '#fff' }} />}
                    disabled={disableScanStop[gatewayCommandId] || !editable || noAccessToEdit}
                  >
                    STOP
                  </Button>
                ) : (
                  <Button
                    variant='contained'
                    onClick={() => scanAssets(String(liveGatewayData.cidr_to_scan ?? ''))}
                    disabled={disableScanStop[gatewayCommandId] || !editable || noAccessToEdit}
                    startIcon={<ScanIcon />}
                    sx={Styles.scanBtn}
                  >
                    SCAN
                  </Button>
                )}
              </Stack>
              {useCase && (
                <Stack sx={{ mt: 2 }}>
                  <Button
                    variant='outlined'
                    sx={Styles.btn}
                    startIcon={<AddCircleIcon />}
                    onClick={() => {
                      onBtnClick('edgeNode', { label: 'Business Rule', type: 'business_rules' });
                    }}
                  >
                    Setup Business Rules
                  </Button>
                </Stack>
              )}
            </Card>
            {editable && !noAccessToEdit && (
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant='outlined'
                  sx={{ width: 'auto', height: '42px' }}
                  startIcon={<ExcelIcon />}
                  onClick={() => {
                    onGatewayImportClick(String(liveGatewayData.gateway_id ?? nodeElement?.id ?? ''), liveGatewayData);
                  }}
                >
                  IMPORT ASSETS
                </Button>
              </Box>
            )}
          </>
        );
      case 'smartAssetNode':
        return (
          <>
            <Card
              sx={{
                ...Styles.card,
                backgroundColor: themeMode.isLightBG
                  ? lighten(themeData.palette.background.default, 0.2)
                  : lighten(themeData.palette.background.default, 0.08),
              }}
            >
              <>
                <Box sx={Styles.listItem}>
                  <Typography sx={Styles.listHeading}>Type:</Typography>
                  <Typography sx={Styles.listText}>Smart asset</Typography>
                </Box>
                <Box sx={Styles.listItem}>
                  <Typography sx={Styles.listHeading}>Name:</Typography>
                  <Typography sx={Styles.listText}>{nodeElement.data.asset_name ?? 'No device name setup'}</Typography>
                </Box>
              </>
            </Card>
            {readonly
              ? renderParamsTable(telemetry['smart-' + nodeElement.data.asset_id]?.properties ?? [])
              : renderJsonDataTable(activeNode?.data)}
          </>
        );
      default:
        return (
          <>
            <Card
              sx={{
                ...Styles.card,
                backgroundColor: themeMode.isLightBG
                  ? lighten(themeData.palette.background.default, 0.2)
                  : lighten(themeData.palette.background.default, 0.08),
              }}
            >
              {renderCardData(nodeElement)}
            </Card>
            {readonly
              ? renderParamsTable(
                item?.props.map((prop: any) => {
                  const gateways = getIncomers(activeNode, nodes, edges);
                  const gateway = gateways?.[0] ?? [];
                  const value =
                    telemetry[gateway.id]?.properties?.find((p: any) => p.name === prop.key)?.value ?? 'NOT_FOUND';
                  return { ...prop, value };
                }) ?? []
              )
              : renderJsonDataTable(activeNode?.data)}
          </>
        );
    }
  };

  const closeDeleteComponentConfirmation = () => {
    setDeleteComponentConfirmation({ open: false, compId: '' });
  };

  const minDrawerWidth = 780;
  const maxDrawerWidth = document.body.offsetWidth;

  const [drawerWidth, setDrawerWidth] = useState(minDrawerWidth);

  const handleMouseMove = (e: any) => {
    const newWidth = document.body.offsetWidth - e.clientX;
    if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
      setDrawerWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    document.removeEventListener('mouseup', handleMouseUp, true);
    document.removeEventListener('mousemove', handleMouseMove, true);
    document.body.style.userSelect = 'auto';
  };

  const handleMouseDown = () => {
    document.addEventListener('mouseup', handleMouseUp, true);
    document.addEventListener('mousemove', handleMouseMove, true);
    document.body.style.userSelect = 'none';
  };

  function validateConfig(
    data: any,
    secretData: any,
    requiredParams: any
  ): any {
    const errors: string[] = [];
    const reportedErrors = new Set<string>();

    // Ensure data, secretData, and requiredParams are valid
    if (!data || typeof data !== 'object' || isEmpty(data)) {
      return { secret_message: errors }; // Return early if data is invalid
    }

    if (!Array.isArray(secretData)) {
      secretData = []; // Default to an empty array if secretData is invalid
    }

    if (!Array.isArray(requiredParams)) {
      requiredParams = []; // Default to an empty array if requiredParams is invalid
    }

    // Extract secret IDs from config
    const secretIds = Object.entries(data)
      .filter(([_, value]: any) => typeof value === 'string' && value.startsWith('secret:'))
      .map(([key, value]: any) => ({
        key,
        secretId: parseInt(value.split(':')[1], 10),
      }));

    // Collect all keys from the selected secrets
    const collectedKeys = new Set<string>();
    secretIds.forEach(({ key, secretId }: any) => {
      const secret = secretData.find((s: any) => s.secret_id === secretId);

      if (secret && Array.isArray(secret.secret_keys_list)) {
        secret.secret_keys_list.forEach((key: string) => collectedKeys.add(key));
      } else {
        // Optionally, add an error if the secret is not found
        // errors.push(`${key} value not selected`);
      }
    });

    // Check if all requiredParams are satisfied by the collected keys
    const missingParams = requiredParams.filter(
      (requiredSecret: string) => !collectedKeys.has(requiredSecret)
    );

    // Add errors only for missing requiredParams
    missingParams.forEach((requiredSecret: string) => {
      const errorMessage = `${requiredSecret} is missing`;
      if (!reportedErrors.has(errorMessage)) {
        errors.push(errorMessage);
        reportedErrors.add(errorMessage); // Mark this error as reported
      }
    });

    return { secret_message: errors };
  }

  return (
    <>
      <Modal title={'Tags scanned'} open={tagsView} handleClose={() => setTagsView(false)}>
        <Card
          sx={{
            ...CommonStyles.card,
            backgroundColor: themeMode.isLightBG
              ? lighten(themeData.palette.background.default, 0.9)
              : lighten(themeData.palette.background.default, 0.05),
          }}
        >
          <CardContent sx={{ ...CommonStyles.cardContent, backgroundColor: 'transparent' }}>
            {/* <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Address</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activeComponent?.data?.scan_result?.length > 0 ? (
                  activeComponent?.data?.scan_result?.map((tag: any) => (
                    <TableRow>
                      <TableCell>{tag.name}</TableCell>
                      <TableCell>{tag.id}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{ height: '200px' }}>
                    <TableCell colSpan={2} sx={{ textAlign: 'center' }}>
                      No tags scanned
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table> */}
            <ScanResults scanData={get(activeComponent, 'data.scan_result')} schema={get(activeComponent, 'backend_schema.scanResult')} />
            <Grid container sx={{ marginTop: '32px' }}>
              <Grid xs={12} textAlign={'center'} sx={{ paddingBottom: '24px' }}>
                <Button
                  variant='outlined'
                  sx={{ mr: 3, width: '100px', height: '42px' }}
                  onClick={() => setTagsView(false)}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Modal>
      <Drawer anchor='right' open={isDrawerOpen} hideBackdrop PaperProps={{ style: { width: drawerWidth } }}>
        <div
          id='dragger'
          onMouseDown={(event) => {
            handleMouseDown();
          }}
          style={{
            width: '5px',
            // backgroundColor: 'red',
            cursor: 'ew-resize',
            padding: '4px 0 0',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <ResizeIcon />
        </div>
        <Box
          sx={{
            ...Styles.Sidebar,
            backgroundColor: themeMode.isLightBG
              ? lighten(themeData.palette.background.default, 0.9)
              : lighten(themeData.palette.background.default, 0.05),
          }}
        >
          <Box sx={{ ...Styles.header, alignItems: 'flex-start' }}>
            <Box sx={{ ...Styles.titleWrapper, alignItems: 'flex-start' }}>
              <Box sx={{ marginTop: '5px' }}>
                {readonly ? (
                  <ListAltRounded style={{ color: themeData.palette.custom.light }} />
                ) : (
                  <SettingsIcon style={{ color: themeData.palette.custom.light }} />
                )}
              </Box>

              <Typography sx={{
                ...Styles.title, display: 'block',
                wordWrap: 'break-word',
                overflow: 'hidden',
                whiteSpace: 'break-spaces',
                maxWidth: `${drawerWidth - 150}px`
              }}>
                {nodeElement.part_name ?? activeNode?.data.name ?? activeNode?.display}{' '}
                {readonly ? 'PARAMETERS' : 'SETTINGS'}
              </Typography>
            </Box>
            <IconButton onClick={toggleDrawer} sx={{padding:0, marginTop:'2px'}}>
              <CloseIcon style={{ ...Styles.closeIcon, color: themeData.palette.custom.light }} />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={Styles.body}>
            {renderBody(activeNode?.type, { ...activeNode?.data, id: activeNode?.id  })}
            {(assetComponentsLoading) && (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bgcolor: 'rgba(255, 255, 255, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            )}
          </Box>
          <Divider />
          <Box sx={Styles.footer}>
            <Button variant='outlined' onClick={toggleDrawer}>
              Close
            </Button>
          </Box>
        </Box>
      </Drawer>

      <PopUp
        open={deleteComponentConfirmation.open}
        icon={<AlertIcon color={palette.warning.main} />}
        message='Are you sure you want to delete this component?'
        cancel
        confirmation
        cancelLabel='No'
        confirmLabel='Yes'
        onConfirm={() => {
          const opts = (activeNode.data?.options ?? []).filter(
            (option: any) => option.id !== deleteComponentConfirmation.compId
          );
          const dltComp = (activeNode.data?.options ?? []).find(
            (option: any) => option.id === deleteComponentConfirmation.compId && option.operation !== 'added'
          );
          updateNodeData({
            ...activeNode.data,
            options: opts,
          });
          // setRemovedComponents((prev: any) => [...prev, { ...dltComp, assetId: activeNode.id }]);
          if(dltComp) {
            setRemovedComponents((prev: any) => ({ ...prev, [activeNode.id]: [...(prev[activeNode.id] || []), { ...dltComp, assetId: activeNode.id }]}));
          }
          setJsonFormError((prev: any) => {
            const prevItems = { ...prev };
            if (prevItems[`component-${deleteComponentConfirmation.compId}`]) {
              delete prevItems[`component-${deleteComponentConfirmation.compId}`];
            }
            return prevItems;
          });
          closeDeleteComponentConfirmation();
        }}
        onClose={closeDeleteComponentConfirmation}
        onCancel={closeDeleteComponentConfirmation}
      />
      <PopUp
        open={jsonFormAlertPopup.open}
        icon={
          <Box
            bgcolor='#fff'
            width='100%'
            sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
          >
            <AlertIcon color={palette.warning.main} />
            <Typography color='#FF8800'>WARNING(s)</Typography>
          </Box>
        }
        message={jsonFormAlertPopup.msg}
        confirmation={true}
        confirmLabel='Continue'
        cancel
        cancelLabel='Cancel'
        onCancel={() => setJsonFormAlertPopup({ open: false, msg: '' })}
        onClose={() => setJsonFormAlertPopup({ open: false, msg: '' })}
        onConfirm={() => {
          setIsDrawerOpen(false);
          setJsonFormAlertPopup({ open: false, msg: '' });
          setJsonFormError({});
        }}
      />
      <PopUp
        open={jsonFormErrorPopup.open}
        icon={
          <Box
            bgcolor='#fff'
            width='100%'
            sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
          >
            <AlertIcon color={palette.error.main} />
            <Typography color='#FF0000'>ERROR(s)</Typography>
          </Box>
        }
        message={jsonFormErrorPopup.msg}
        cancel
        cancelLabel='Cancel'
        onCancel={() => setJsonFormErrorPopup({ open: false, msg: '' })}
        onClose={() => setJsonFormErrorPopup({ open: false, msg: '' })}
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  components: state.componentMaster.componentMasterData,
  assetComponentsLoading: state.factoryManagement.assetComponentsLoading,
  assetComponents: state.factoryManagement.assetComponentsData,
  secretsList: state.secretsManager.secretsData,
  loadingCopyConfigurationFromComponent: state.factoryManagement.loadingCopyConfigurationFromComponent,
});

export default connect(mapStateToProps)(memo(Sidebar));
